import React from "react";
import { Route } from "react-router";
import BuildOrderPage from "pages/OrderPages/BuildOrderPage/BuildOrderPage";
import ViewPriceEstimatesPage from "pages/OrderPages/ViewPriceEstimatesPage/ViewPriceEstimatesPage";
import NewOrderShippingDetailsPage from "pages/OrderPages/NewOrderShippingDetailsPage/NewOrderShippingDetailsPage";
import NewOrderFormProvider from "pages/OrderPages/NewOrderShippingDetailsPage/contexts/Form/NewOrderFormProvider";
import ReviewOrderPage from "pages/OrderPages/ReviewOrderPage/ReviewOrderPage";
import NewOrderConfirmationPage from "pages/OrderPages/NewOrderConfirmation/NewOrderConfirmation";

export const CustomColorRoutes = (
	<Route path="custom-color">
		<Route
			path="build-order/:draftId?"
			element={<BuildOrderPage isCustomColor />}
		/>
		<Route
			path="view-price-estimates"
			element={<ViewPriceEstimatesPage isCustomColor />}
		/>
		<Route
			path="shipping-details"
			element={
				<NewOrderFormProvider>
					<NewOrderShippingDetailsPage isCustomColor />
				</NewOrderFormProvider>
			}
		/>
		<Route
			path="review-order"
			element={<ReviewOrderPage isCustomColor />}
		/>
		<Route
			path="confirmation"
			element={<NewOrderConfirmationPage isCustomColor />}
		/>
	</Route>
);
